import React, { Component } from "react";

import ProjectList from "./ProjectList";

import { PrimaryButton } from '../Ui'

import Icon from "../common/components/Icon";

class ProjectListContainer extends Component {
	render() {

		if(this.props.UIState === "blank") {
			return (
				<div className="c-project-list">
					<header className="c-list__header">Mes projets</header>
					<div className="u-flex u-flex--col u-flex--justify-center u-flex--align-items-center" style={{width: "300px", marginTop: "100px", color: "#C9C9C9", fill: "#C9C9C9"}}>
						<p style={{fontSize: "50px"}}>0</p>
						<p style={{marginBottom: "30px", fontSize: "20px"}}>Projet en cours</p>
						<PrimaryButton
							onClick={this.props.openProjectForm.bind(null, false)}>

							Créer un projet
						</PrimaryButton>
					</div>
				</div>
			);
		}

		return (
			<div className="c-project-list no-shrink">
				<header className="c-list__header">Mes projets</header>
				<ProjectList
					headerText="Mes projets"
					selectedProjectId={this.props.selectedProjectId}
					projects={this.props.projects}
					onClick={this.props.onClick} />
				{/* TODO: display closed project list */}
				<div style={{position: "absolute", bottom: "0", left: "0", right: "0"}}>
					<PrimaryButton
						fillWidth
						block
						onClick={this.props.openProjectForm.bind(null, false)}>

						Créer un projet
					</PrimaryButton>
				</div>
			</div>
		);
	}
}

export default ProjectListContainer;



// WEBPACK FOOTER //
// ./src/js/project-v2/ProjectListContainer.js